import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { UserProfile } from "src/app/parametrage/core/model/user-profile";
import { EmployeeService } from "src/app/parametrage/core/service/employee.service";
import { Employee } from "src/app/parametrage/core/model/employee/employee";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { Request } from "src/app/parametrage/core/model/request";
import { ChangerInitiateurDossier } from "src/app/parametrage/core/model/request/changer-initiateur-dossier";

@Component({
  selector: "app-changer-initiateur-dossier",
  templateUrl: "./changer-initiateur-dossier.component.html",
  styleUrls: ["./changer-initiateur-dossier.component.scss"],
})
export class ChangerInitiateurDossierComponent implements OnInit {
  @Input() requestId;

  form2: FormGroup;
  pressButton: Boolean = false;

  request: Request;

  userProfiles: UserProfile[];
  employees: Employee[];

  command: ChangerInitiateurDossier = new ChangerInitiateurDossier();

  errorMessage: String = null;

  constructor(
    private _router: Router,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private _employeeService: EmployeeService,
    private _requestService: RequestService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      userAffected: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getRequestById(this.requestId);
    this.getUsers();
  }

  getUsers() {
    this._employeeService.getEmployeesAllege().subscribe(
      (data) => {
        this.employees = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getRequestById(requestId) {
    this._requestService.getRequestById(requestId).subscribe(
      (data) => {
        this.request = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.pressButton = true;
    this.command.requestId = this.requestId;
    this.command.backupId = this.form2.value.userAffected;
    this._requestService
      .changerInitiateur(this.command)
      .pipe(first())
      .subscribe(
        (data) => {
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.errorMessage = error.error.message;
        }
      );
  }
}
